/**
 * @generated SignedSource<<c1709a80e36947ed53cc5fdb91c959bb>>
 * @relayHash 1d7978276593abc4d0c81cb4c5f9ff1c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1d7978276593abc4d0c81cb4c5f9ff1c

import { ConcreteRequest } from 'relay-runtime';
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type CareProviderSearchType = "ADVANCED_SEARCH" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE_WITHOUT_SPECIALTY" | "HOSPITAL_ELECTIVE_WITH_SPECIALTY" | "HOSPITAL_EMERGENCY_ROOM" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "NONE" | "PRESCRIPTION_DOCUMENT" | "SPECIALIST_WITHOUT_SPECIALTY" | "SPECIALIST_WITH_SPECIALTY" | "THERAPY_PRESCRIPTION_NEUROPSYCHOLOGIC_DIAGNOSTIC_DOCUMENT" | "THERAPY_PRESCRIPTION_NUTRITIONAL_COUNSELLING_DOCUMENT" | "THERAPY_PRESCRIPTION_PHYSIOTHERAPY_DOCUMENT" | "THERAPY_PRESCRIPTION_PSYCHOLOGICAL_PSYCHOTHERAPY_DOCUMENT" | "TIME_WINDOW_WITH_REFERRAL_TO" | "TIME_WINDOW_WITH_REFERRED_BY";
export type DayOfWeek = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type WorkingType = "CLOSED" | "HOURLY" | "OPEN24_HOURS";
export type AddressInput = {
  city: string;
  countryCode: string;
  houseNumberStreet: string;
  postalCode: string;
};
export type useCareProviderQuickListQuery$variables = {
  address?: AddressInput | null;
  language: string;
  patientId: string;
  searchType: CareProviderSearchType;
  showInsurerNetwork: boolean;
  specialtyId?: string | null;
};
export type useCareProviderQuickListQuery$data = {
  readonly ch_careProviderQuickList: {
    readonly insurerNetwork?: {
      readonly applicableInsuranceCareProviderListIds: ReadonlyArray<string>;
      readonly careProviders: ReadonlyArray<{
        readonly businessName: string | null;
        readonly careProviderGroupId: string;
        readonly careProviderGroupQuickList: {
          readonly groupType: CareProviderGroupType;
        };
        readonly careProviderSpecialtyTranslations: ReadonlyArray<{
          readonly name: string;
        }>;
        readonly city: string | null;
        readonly country: {
          readonly countryName: string | null;
        } | null;
        readonly countryCode: string | null;
        readonly creditorCodeRegister: string | null;
        readonly detailedSchedule: ReadonlyArray<{
          readonly day: DayOfWeek;
          readonly periods: ReadonlyArray<{
            readonly end: string;
            readonly start: string;
          }> | null;
          readonly workingType: WorkingType;
        }> | null;
        readonly firstName: string | null;
        readonly groupName: string | null;
        readonly id: string;
        readonly insuranceCareProviderListIds: ReadonlyArray<string> | null;
        readonly isMedgatePartnerNetworkMember: boolean | null;
        readonly isTakesNewPatients: boolean | null;
        readonly lastName: string | null;
        readonly network: {
          readonly name: string;
        } | null;
        readonly partyType: string | null;
        readonly postalCode: string | null;
        readonly relationBusinessName: string | null;
        readonly relationFirstName: string | null;
        readonly relationLastName: string | null;
        readonly relationTitle: string | null;
        readonly relationType: string | null;
        readonly streetAddress: string | null;
        readonly title: string | null;
      }>;
    } | null;
    readonly personalCareProviders: ReadonlyArray<{
      readonly businessName: string | null;
      readonly careProviderGroupId: string;
      readonly careProviderGroupQuickList: {
        readonly groupType: CareProviderGroupType;
      };
      readonly careProviderSpecialtyTranslations: ReadonlyArray<{
        readonly name: string;
      }>;
      readonly city: string | null;
      readonly country: {
        readonly countryName: string | null;
      } | null;
      readonly countryCode: string | null;
      readonly creditorCodeRegister: string | null;
      readonly detailedSchedule: ReadonlyArray<{
        readonly day: DayOfWeek;
        readonly periods: ReadonlyArray<{
          readonly end: string;
          readonly start: string;
        }> | null;
        readonly workingType: WorkingType;
      }> | null;
      readonly firstName: string | null;
      readonly groupName: string | null;
      readonly id: string;
      readonly insuranceCareProviderListIds: ReadonlyArray<string> | null;
      readonly isMedgatePartnerNetworkMember: boolean | null;
      readonly isTakesNewPatients: boolean | null;
      readonly lastName: string | null;
      readonly network: {
        readonly name: string;
      } | null;
      readonly partyType: string | null;
      readonly postalCode: string | null;
      readonly relationBusinessName: string | null;
      readonly relationFirstName: string | null;
      readonly relationLastName: string | null;
      readonly relationTitle: string | null;
      readonly relationType: string | null;
      readonly streetAddress: string | null;
      readonly title: string | null;
    }>;
    readonly preselectedCareProviderId?: string | null;
  };
};
export type useCareProviderQuickListQuery = {
  response: useCareProviderQuickListQuery$data;
  variables: useCareProviderQuickListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "address"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showInsurerNetwork"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialtyId"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "address",
        "variableName": "address"
      },
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      },
      {
        "kind": "Variable",
        "name": "searchType",
        "variableName": "searchType"
      },
      {
        "kind": "Variable",
        "name": "specialtyId",
        "variableName": "specialtyId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "careProviderGroupId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v17 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v18 = {
  "alias": null,
  "args": (v17/*:: as any*/),
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditorCodeRegister",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupType",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTakesNewPatients",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMedgatePartnerNetworkMember",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insuranceCareProviderListIds",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": (v17/*:: as any*/),
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v26 = [
  (v25/*:: as any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationType",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partyType",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationBusinessName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationFirstName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationLastName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationTitle",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "DaySchedule",
  "kind": "LinkedField",
  "name": "detailedSchedule",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workingType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimePeriod",
      "kind": "LinkedField",
      "name": "periods",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  (v7/*:: as any*/),
  (v8/*:: as any*/),
  (v9/*:: as any*/),
  (v10/*:: as any*/),
  (v11/*:: as any*/),
  (v12/*:: as any*/),
  (v13/*:: as any*/),
  (v14/*:: as any*/),
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CountryLookup",
    "kind": "LinkedField",
    "name": "country",
    "plural": false,
    "selections": [
      (v18/*:: as any*/)
    ],
    "storageKey": null
  },
  (v19/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CareProviderGroup",
    "kind": "LinkedField",
    "name": "careProviderGroupQuickList",
    "plural": false,
    "selections": [
      (v20/*:: as any*/)
    ],
    "storageKey": null
  },
  (v21/*:: as any*/),
  (v22/*:: as any*/),
  (v23/*:: as any*/),
  (v24/*:: as any*/),
  {
    "alias": null,
    "args": (v17/*:: as any*/),
    "concreteType": "SpecialtyTranslation",
    "kind": "LinkedField",
    "name": "careProviderSpecialtyTranslations",
    "plural": true,
    "selections": (v26/*:: as any*/),
    "storageKey": null
  },
  (v27/*:: as any*/),
  (v28/*:: as any*/),
  (v29/*:: as any*/),
  (v30/*:: as any*/),
  (v31/*:: as any*/),
  (v32/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_Network",
    "kind": "LinkedField",
    "name": "network",
    "plural": false,
    "selections": (v26/*:: as any*/),
    "storageKey": null
  },
  (v33/*:: as any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "applicableInsuranceCareProviderListIds",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preselectedCareProviderId",
  "storageKey": null
},
v37 = [
  (v25/*:: as any*/),
  (v7/*:: as any*/)
],
v38 = [
  (v7/*:: as any*/),
  (v8/*:: as any*/),
  (v9/*:: as any*/),
  (v10/*:: as any*/),
  (v11/*:: as any*/),
  (v12/*:: as any*/),
  (v13/*:: as any*/),
  (v14/*:: as any*/),
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CountryLookup",
    "kind": "LinkedField",
    "name": "country",
    "plural": false,
    "selections": [
      (v18/*:: as any*/),
      (v7/*:: as any*/)
    ],
    "storageKey": null
  },
  (v19/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CareProviderGroup",
    "kind": "LinkedField",
    "name": "careProviderGroupQuickList",
    "plural": false,
    "selections": [
      (v20/*:: as any*/),
      (v7/*:: as any*/)
    ],
    "storageKey": null
  },
  (v21/*:: as any*/),
  (v22/*:: as any*/),
  (v23/*:: as any*/),
  (v24/*:: as any*/),
  {
    "alias": null,
    "args": (v17/*:: as any*/),
    "concreteType": "SpecialtyTranslation",
    "kind": "LinkedField",
    "name": "careProviderSpecialtyTranslations",
    "plural": true,
    "selections": (v37/*:: as any*/),
    "storageKey": null
  },
  (v27/*:: as any*/),
  (v28/*:: as any*/),
  (v29/*:: as any*/),
  (v30/*:: as any*/),
  (v31/*:: as any*/),
  (v32/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_Network",
    "kind": "LinkedField",
    "name": "network",
    "plural": false,
    "selections": (v37/*:: as any*/),
    "storageKey": null
  },
  (v33/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCareProviderQuickListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "CareProviderQuickListOutput",
        "kind": "LinkedField",
        "name": "ch_careProviderQuickList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProviderSearchResult",
            "kind": "LinkedField",
            "name": "personalCareProviders",
            "plural": true,
            "selections": (v34/*:: as any*/),
            "storageKey": null
          },
          {
            "condition": "showInsurerNetwork",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InsurerNetworkOutput",
                "kind": "LinkedField",
                "name": "insurerNetwork",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProviderSearchResult",
                    "kind": "LinkedField",
                    "name": "careProviders",
                    "plural": true,
                    "selections": (v34/*:: as any*/),
                    "storageKey": null
                  },
                  (v35/*:: as any*/)
                ],
                "storageKey": null
              },
              (v36/*:: as any*/)
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/),
      (v5/*:: as any*/),
      (v0/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useCareProviderQuickListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "CareProviderQuickListOutput",
        "kind": "LinkedField",
        "name": "ch_careProviderQuickList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProviderSearchResult",
            "kind": "LinkedField",
            "name": "personalCareProviders",
            "plural": true,
            "selections": (v38/*:: as any*/),
            "storageKey": null
          },
          {
            "condition": "showInsurerNetwork",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InsurerNetworkOutput",
                "kind": "LinkedField",
                "name": "insurerNetwork",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProviderSearchResult",
                    "kind": "LinkedField",
                    "name": "careProviders",
                    "plural": true,
                    "selections": (v38/*:: as any*/),
                    "storageKey": null
                  },
                  (v35/*:: as any*/)
                ],
                "storageKey": null
              },
              (v36/*:: as any*/)
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1d7978276593abc4d0c81cb4c5f9ff1c",
    "metadata": {},
    "name": "useCareProviderQuickListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da5ad213635c740f3ee2137b32c23f76";

export default node;
